export const digitalNoticeboardTemplateConstants = {
  BASE_PATH: '/v1/digital_noticeboard_templates',
  GET_DIGITAL_NOTICEBOARD_TEMPLATES: 'GET_DIGITAL_NOTICEBOARD_TEMPLATES',
  SET_DIGITAL_NOTICEBOARDS_TEMPLATES_LOADING: 'SET_DIGITAL_NOTICEBOARDS_TEMPLATES_LOADING',
};
